<template>
  <div>
    <div class="top-wrap clear">
      <ul class="clear fl">
        <li class="date-type fl" :class="item.isActive?'active':''" v-for="item in date_type_list" :key="item.id" @click="chooseDateType(item)">{{item.name}}</li>
      </ul>
      <el-button class="fr down-btn">下载</el-button>
      <el-button class="fr print-btn">打印</el-button>
    </div>
    <div class="con-wrap">
      <span class="name">日期:</span>
      <el-date-picker
        v-model="date"
        type="month"
        placeholder="请选择日期">
      </el-date-picker>
      <span class="name">报表类型:</span>
      <el-select v-model="category">
        <el-option v-for="item in category_list" :label="item.name" :value="item.id" :key="item.id"></el-option>
      </el-select>
      <span class="name">商户/表:</span>
      <el-select v-model="user">
        <el-option v-for="item in user_list" :label="item.name" :value="item.id" :key="item.id"></el-option>
      </el-select>
      <el-button>查询</el-button>
      <span class="name">费率：元/吨</span>
      <span class="name">标准水量：9.5</span>
      <span class="name">超出标准水量20%：19</span>
      <span class="name">超出标准水量40%：28.5</span>
      <el-table
        :data="table_data"
        border
        :height="tableHeight"
        stripe>
        <el-table-column label="商户" prop="category_name"></el-table-column>
        <el-table-column label="本月用水量（t）" width="150" prop="total"></el-table-column>
        <el-table-column label="1日" prop="1"></el-table-column>
        <el-table-column label="2日" prop="2"></el-table-column>
        <el-table-column label="3日" prop="3"></el-table-column>
        <el-table-column label="4日" prop="4"></el-table-column>
        <el-table-column label="5日" prop="5"></el-table-column>
        <el-table-column label="6日" prop="6"></el-table-column>
        <el-table-column label="7日" prop="7"></el-table-column>
        <el-table-column label="8日" prop="8"></el-table-column>
        <el-table-column label="9日" prop="9"></el-table-column>
        <el-table-column label="10日" prop="10"></el-table-column>
        <el-table-column label="11日" prop="11"></el-table-column>
        <el-table-column label="12日" prop="12"></el-table-column>
        <el-table-column label="13日" prop="13"></el-table-column>
        <el-table-column label="14日" prop="14"></el-table-column>
        <el-table-column label="15日" prop="15"></el-table-column>
        <el-table-column label="16日" prop="16"></el-table-column>
        <el-table-column label="17日" prop="17"></el-table-column>
        <el-table-column label="18日" prop="18"></el-table-column>
        <el-table-column label="19日" prop="19"></el-table-column>
        <el-table-column label="20日" prop="20"></el-table-column>
        <el-table-column label="21日" prop="21"></el-table-column>
        <el-table-column label="22日" prop="22"></el-table-column>
        <el-table-column label="23日" prop="23"></el-table-column>
        <el-table-column label="24日" prop="24"></el-table-column>
        <el-table-column label="25日" prop="25"></el-table-column>
        <el-table-column label="26日" prop="26"></el-table-column>
        <el-table-column label="27日" prop="27"></el-table-column>
        <el-table-column label="28日" prop="28"></el-table-column>
        <el-table-column label="29日" prop="29"></el-table-column>
        <el-table-column label="30日" prop="30"></el-table-column>
      </el-table>

    </div>
  </div>
</template>

<script>
export default {
  name: "customerWaterReport",
  data(){
    return{
      date_type_list: [
        {
          id: 0,
          name: "年报表",
          isActive: true
        },
        {
          id: 1,
          name: "月报表",
          isActive: false
        }
      ],
      date: '',
      table_data: [{"category_name":"\u603b\u8ba1","total":0,"1":0,"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0},{"category_name":"B\u5ea7\u4e2d\u5546\u6c11\u751f\u94f6\u884c","total":0,"1":"0.0","2":"0.0","3":"0.0","4":"0.0","5":"0.0","6":"0.0","7":"0.0","8":"0.0","9":"0.0","10":"0.0","11":"0.0","12":"0.0","13":"0.0","14":"0.0","15":"0.0","16":"0.0","17":"0.0","18":"0.0","19":"0.0","20":"0.0","21":"0.0","22":"0.0","23":"0.0","24":"0.0","25":"0.0","26":"0.0","27":"0","28":"0","29":"0","30":"0"},{"category_name":"\u7a3b\u76db\u548c\u592b","total":0,"1":"0.0","2":"0.0","3":"0.0","4":"0.0","5":"0.0","6":"0.0","7":"0.0","8":"0.0","9":"0.0","10":"0.0","11":"0.0","12":"0.0","13":"0.0","14":"0.0","15":"0.0","16":"0.0","17":"0.0","18":"0.0","19":"0.0","20":"0.0","21":"0.0","22":"0.0","23":"0.0","24":"0.0","25":"0.0","26":"0.0","27":"0","28":"0","29":"0","30":"0"},{"category_name":"\u805a\u70b9\u4e32\u5427","total":0,"1":"0.0","2":"0.0","3":"0.0","4":"0.0","5":"0.0","6":"0.0","7":"0.0","8":"0.0","9":"0.0","10":"0.0","11":"0.0","12":"0.0","13":"0.0","14":"0.0","15":"0.0","16":"0.0","17":"0.0","18":"0.0","19":"0.0","20":"0.0","21":"0.0","22":"0.0","23":"0.0","24":"0.0","25":"0.0","26":"0.0","27":"0","28":"0","29":"0","30":"0"},{"category_name":"\u60a0\u5802\u4e32\u5427","total":0,"1":"0.0","2":"0.0","3":"0.0","4":"0.0","5":"0.0","6":"0.0","7":"0.0","8":"0.0","9":"0.0","10":"0.0","11":"0.0","12":"0.0","13":"0.0","14":"0.0","15":"0.0","16":"0.0","17":"0.0","18":"0.0","19":"0.0","20":"0.0","21":"0.0","22":"0.0","23":"0.0","24":"0.0","25":"0.0","26":"0.0","27":"0","28":"0","29":"0","30":"0"},{"category_name":"\u89c6\u901a\u5929\u5730\u673a\u623f","total":0,"1":"0.0","2":"0.0","3":"0.0","4":"0.0","5":"0.0","6":"0.0","7":"0.0","8":"0.0","9":"0.0","10":"0.0","11":"0.0","12":"0.0","13":"0.0","14":"0.0","15":"0.0","16":"0.0","17":"0.0","18":"0.0","19":"0.0","20":"0.0","21":"0.0","22":"0.0","23":"0.0","24":"0.0","25":"0.0","26":"0.0","27":"0","28":"0","29":"0","30":"0"},{"category_name":"\u9f99\u798f\u5babB1\u8fdb\u95e8","total":0,"1":"0.0","2":"0.0","3":"0.0","4":"0.0","5":"0.0","6":"0.0","7":"0.0","8":"0.0","9":"0.0","10":"0.0","11":"0.0","12":"0.0","13":"0.0","14":"0.0","15":"0.0","16":"0.0","17":"0.0","18":"0.0","19":"0.0","20":"0.0","21":"0.0","22":"0.0","23":"0.0","24":"0.0","25":"0.0","26":"0.0","27":"0","28":"0","29":"0","30":"0"},{"category_name":"\u70ed\u5904\u7406\u5c0f\u697c1\u5c42\u536b\u751f\u95f4","total":0,"1":"0.0","2":"0.0","3":"0.0","4":"0.0","5":"0.0","6":"0.0","7":"0.0","8":"0.0","9":"0.0","10":"0.0","11":"0.0","12":"0.0","13":"0.0","14":"0.0","15":"0.0","16":"0.0","17":"0.0","18":"0.0","19":"0.0","20":"0.0","21":"0.0","22":"0.0","23":"0.0","24":"0.0","25":"0.0","26":"0.0","27":"0","28":"0","29":"0","30":"0"},{"category_name":"E\u5ea7\u5ba4\u5185","total":0,"1":"0.0","2":"0.0","3":"0.0","4":"0.0","5":"0.0","6":"0.0","7":"0.0","8":"0.0","9":"0.0","10":"0.0","11":"0.0","12":"0.0","13":"0.0","14":"0.0","15":"0.0","16":"0.0","17":"0.0","18":"0.0","19":"0.0","20":"0.0","21":"0.0","22":"0.0","23":"0.0","24":"0.0","25":"0.0","26":"0.0","27":"0","28":"0","29":"0","30":"0"},{"category_name":"\u7f512\u5bbf\u820d","total":0,"1":0,"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0}],
      category: '0',
      category_list: [
        {
          id: '0',
          name: '全部'
        }
      ],
      user: '0',
      user_list: [
        {
          id: '0',
          name: '全部'
        }
      ],
      tableHeight:626,
    }
  },
  created(){
    window.addEventListener('resize', this.getHeight)
  },
  beforeDestroy(){
    window.removeEventListener('resize', this.getHeight)
  },
  methods: {
    getHeight () {
      this.tableHeight = window.innerHeight - 320
    },
    chooseDateType(value){
      for(let i in this.date_type_list){
        this.date_type_list[i].isActive = false
      }
      value.isActive = true;
      console.log(value.name)
    }
  }
}
</script>

<style scoped lang="scss">
.top-wrap{
  width: 100%;
  padding-top: 15px;
  padding-left: 10px;
  .down-btn,.print-btn{
    margin-right: 10px;
  }
}
.con-wrap{
  //height: 650px;
  padding: 20px;
  color: #ffffff;
  .name{
    margin-right: 10px;
    margin-left: 30px;
    &:first-child{
      margin-left: 5px;
    }
  }
  .el-button{
    margin-left: 10px;
  }
  .el-table{
    margin-top: 20px;
  }
}
.date-type{
  display: inline-block;
  width: 80px;
  height: 32px;
  line-height: 32px;
  text-align: center;
  margin-right: 8px;
  color: #ffffff;
  background-color: #000;
  cursor: pointer;
}
.active{
  background-color: #376cf2;
}
</style>
